import { render, staticRenderFns } from "./Division.vue?vue&type=template&id=19d88f86&scoped=true"
import script from "./Division.vue?vue&type=script&lang=js"
export * from "./Division.vue?vue&type=script&lang=js"
import style0 from "./Division.vue?vue&type=style&index=0&id=19d88f86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d88f86",
  null
  
)

export default component.exports